const Errors = Object.freeze({
  NoAuthenticatedUser: 'No user authenticated',
  InvalidCredentials: 'There is no user created with those credentials',
  InvalidRole: 'The user does not have permission to access this page',
});

export default Errors;
